import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.scss'

const Profile = (props) => {
    let classNames = styles.profile

    const inputId = `profile_${props.name}`

    const radioProps = {
        id: inputId,
        type: 'radio',
        name: 'profile',
        value: props.name,
    }

    if (props.selected) {
        classNames = `${classNames} ${styles.selected}`
        radioProps.defaultChecked = 'checked'
    }

    return (
        // eslint-disable-next-line
        <li className={classNames} onClick={() => props.setProfile()}>
            <label htmlFor={inputId} className={styles.radio}>
                <input {...radioProps} />
                <span className={styles.outer}>
                    <span className={styles.inner} />
                </span>
                {props.name}
            </label>
        </li>
    )
}

Profile.propTypes = {
    name: PropTypes.string,
    selected: PropTypes.bool,
    setProfile: PropTypes.func,
}

export default Profile



// WEBPACK FOOTER //
// ./src/features/ProfileSelector/components/Selector/components/Profile/index.js